import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { SelectLabelOption, SelectLabelOptionsDocument } from 'graphql/types';

const PAGE_COUNT = 100;
export type GetCustomLabelOptionsType = (
  labelId: string,
  queryText: string
) => Promise<SelectLabelOption[]>;

export const useGetCustomLabelOptions = (): GetCustomLabelOptionsType => {
  const client = useApolloClient();

  const getCustomLabelOptions = useCallback(
    async (labelId: string, queryText: string) => {
      const result = await client.query({
        query: SelectLabelOptionsDocument,
        variables: {
          id: labelId,
          input: {
            count: PAGE_COUNT,
            query: queryText
          }
        }
      });
      return result.data?.label?.selectOptions?.items ?? [];
    },
    [client]
  );
  return getCustomLabelOptions;
};
